import t from '@jetshop/intl';
import { Query } from 'react-apollo';
import React, { Fragment, useState } from 'react';
import styled from 'react-emotion';
import ReactModal from 'react-modal';
import SizeguideQuery from './SizeguideQuery.gql';
import { ReactComponent as Cross } from '../../svg/Cross.svg';
import { array } from 'prop-types';

const InfoModalWrapper = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;
`;

const ModalInside = styled('div')`
  position: absolute;
  top: 190px;
  left: 0;
  right: 0;
  background: #fff;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 2rem;
  border: 5px solid #000;

  svg.close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 20px;
    height: 20px;
    color: black;
    use,
    g,
    path {
      fill: black;
    }
  }

  font-family: ${({ theme }) => theme.fonts.primary};

  p {
    margin-bottom: 1rem;
  }
  p a,
  p a:visited {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }

  h2,
  h3,
  h4 {
    text-align: center;
  }

  h2,
  h3,
  h4,
  strong,
  b {
    font-family: ${({ theme }) => theme.fonts.primary};
    text-transform: uppercase;
    letter-spacing: 0.08rem;
  }
  h2 {
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    ${({ theme }) => theme.below.lg} {
      font-size: 1rem;
    }
  }
  strong,
  b {
    font-weight: bold;
  }

  &:after {
    display: none;
  }
  img {
    max-width: 100%;
  }

  table {
    width: 100%;
    text-align: left;
    margin-bottom: 40px;
    p {
      margin: 0;
    }
    tr {
      background: #f3f3f3;
      &:nth-child(even) {
        background: white;
      }
      &:first-of-type {
        font-weight: 600;
      }
      th {
        padding: 5px;
        ${({ theme }) => theme.below.lg} {
          font-size: 12px;
        }
      }
      td {
        padding: 5px;
        ${({ theme }) => theme.below.lg} {
          font-size: 11px;
        }
      }
      td:first-of-type {
        width: 20%;
      }
    }
  }
`;

const InfoLink = styled('button')`
  width: 100%;
  background: transparent;
  text-align: right;
  text-decoration: underline;
  font-size: 14px;
`;

const Title = styled('h2')`
  padding-top: 2rem;
  margin-bottom: 5px;
  text-align: center;
`;

const SizeguideContent = props => {
  return (
    <Query query={SizeguideQuery} variables={{ id: props.sizeguideId }}>
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return `Error!: ${error}`;
        if (data.category) {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: data.category.content
              }}
            />
          );
        }
      }}
    </Query>
  );
};

const Sizeguide = props => {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <InfoLink
        className={`modalLink ${props.type && props.type}`}
        onClick={() => {
          setOpen(!open);
        }}
      >
        {props.link && props.link}
        {props.children && props.children}
      </InfoLink>
      <InfoModalWrapper
        isOpen={open}
        onRequestClose={() => {
          setOpen(false);
        }}
      >
        <ModalInside>
          <Cross
            className="close-icon"
            onClick={() => {
              setOpen(false);
            }}
          />
          <Title>{t('Size guide')}</Title>
          <SizeguideContent sizeguideId={props.sizeguideId} />
          {props.Component && <props.Component {...props} />}
        </ModalInside>
      </InfoModalWrapper>
    </Fragment>
  );
};

export default Sizeguide;
